var Acre = "阿克爾";
var Alagoas = "阿拉戈阿斯";
var Amazonas = "亞馬遜納斯";
var Bahia = "巴伊亞";
var Pernambuco = "伯南布哥";
var Roraima = "羅萊瑪";
var Sergipe = "塞爾吉佩";
var Tocantins = "托坎廷斯";
var PTStates = {
	Acre: Acre,
	Alagoas: Alagoas,
	"Amapá": "阿馬帕",
	Amazonas: Amazonas,
	Bahia: Bahia,
	"Ceará": "塞阿拉",
	"Federal District": "聯邦區",
	"Espírito Santo": "聖埃斯皮里圖",
	"Goiás": "戈亞斯",
	"Maranhão": "馬拉尼昂",
	"Mato Grosso": "馬托格羅索",
	"Mato Grosso do Sul": "南馬托格羅索",
	"Minas Gerais": "米那斯吉拉斯",
	"Pará": "帕拉",
	"Paraíba": "帕拉伊巴",
	"Paraná": "帕拉那",
	Pernambuco: Pernambuco,
	"Piauí": "皮奥伊",
	"Rio de Janeiro": "里約熱內盧",
	"Rio Grande do Norte": "北里奥格蘭德",
	"Rio Grande do Sul": "南里奧格蘭德",
	"Rondônia": "隆多尼亞",
	Roraima: Roraima,
	"Santa Catarina": "聖塔卡塔琳娜",
	"São Paulo": "聖保羅",
	Sergipe: Sergipe,
	Tocantins: Tocantins
};

export { Acre, Alagoas, Amazonas, Bahia, Pernambuco, Roraima, Sergipe, Tocantins, PTStates as default };
